"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-ignore */
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var react_select_1 = __importDefault(require("react-select"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@21st-night/core");
var Select_1 = require("../../Select");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        width: '100%',
        minWidth: 200,
        borderRadius: 8,
        backgroundColor: theme.palette.primary.main,
    },
}); });
var DeckStudentSelect = function (_a) {
    var classNameProp = _a.className, students = _a.students, onChange = _a.onChange, valueProp = _a.value, other = __rest(_a, ["className", "students", "onChange", "value"]);
    var classes = useStyles();
    var theme = styles_1.useTheme();
    var options = [];
    var styles = {
        valueContainer: function (provided) { return (__assign(__assign({}, provided), { padding: '6px 16px', border: 'none', color: '#FFF' })); },
        container: function (provided) { return (__assign(__assign({}, provided), { border: 'none' })); },
        dropdownIndicator: function (provided, state) {
            var _a;
            return (__assign(__assign({}, provided), (_a = { color: state && state.isFocused
                        ? 'rgba(255, 255, 255, 0.4)'
                        : 'rgba(255, 255, 255, 0.7)' }, _a['&:hover'] = {
                color: 'rgba(255, 255, 255, 1)',
            }, _a)));
        },
        clearIndicator: function (provided, state) {
            var _a;
            return (__assign(__assign({}, provided), (_a = { color: state && state.isFocused
                        ? 'rgba(255, 255, 255, 0.4)'
                        : 'rgba(255, 255, 255, 0.7)' }, _a['&:hover'] = {
                color: 'rgba(255, 255, 255, 1)',
            }, _a)));
        },
        singleValue: function (provided) { return (__assign(__assign({}, provided), { color: '#FFF' })); },
        menu: function (provided) { return (__assign(__assign({}, provided), { padding: 0, border: 'none', zIndex: 9999 })); },
        option: function (provided) { return (__assign(__assign({}, provided), { cursor: 'pointer', padding: 20, fontFamily: theme.typography.fontFamily })); },
        control: function (provided) { return (__assign(__assign({}, provided), { cursor: 'pointer', border: 'none', boxShadow: 'none', backgroundColor: 'transparent', fontFamily: theme.typography.fontFamily, fontSize: '20px' })); },
        indicatorSeparator: function () { return ({ display: 'none' }); },
        placeholder: function (provided) { return (__assign(__assign({}, provided), { fontFamily: theme.typography.fontFamily, color: '#FFF' })); },
        input: function (provided) { return (__assign(__assign({}, provided), { color: '#FFF' })); },
    };
    students.forEach(function (student) {
        options.push({
            label: student.email,
            value: student.id,
        });
    });
    // @ts-ignore
    var value = options.find(function (option) { return option.value === valueProp; });
    var handleChange = react_1.useCallback(function (option) {
        var newValue = option
            ? students.find(function (student) { return student.id === option.value; })
            : core_1.ALL_STUDENTS;
        if (!newValue) {
            newValue = core_1.ALL_STUDENTS;
        }
        onChange(newValue);
    }, [onChange, students]);
    return (
    // @ts-ignore
    react_1.default.createElement(react_select_1.default, __assign({ maxMenuHeight: 300, isClearable: true, styles: styles, options: options, components: {
            // @ts-ignore
            SelectMenuList: Select_1.SelectMenuList,
            Option: Select_1.SelectOption,
        }, onChange: handleChange, className: clsx_1.default(classes.root, classNameProp), placeholder: "All students", noOptionsMessage: function () { return 'No matches'; }, value: value }, other)));
};
exports.default = DeckStudentSelect;
//# sourceMappingURL=DeckStudentSelect.js.map